import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lc_long_arrow",
  "use": "lc_long_arrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"lc_long_arrow\"><defs><style type=\"text/css\"></style></defs><path d=\"M 18.204 494.364 l 917.049 0 l 0 35.2711 l -917.049 0 l 0 -35.2711 Z\" fill=\"#5DB1FF\" p-id=\"1259\" /><path d=\"M 829.44 459.094 L 1005.79 512 L 829.44 564.906 Z\" fill=\"#5DB1FF\" p-id=\"1260\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol